import { initialTableShow } from 'utils/settings';
import { colorsNew } from 'components/common/charts/helpers/config';

export const mainTableConf = [
  {
    isSortable: true,
    field: 'requesterName',
    title: 'Requested By',
    show: true,
    width: 332,
    valuesExport: ['requesterName', 'requesterEmail']
  },
  {
    isSortable: true,
    field: 'type',
    title: 'Type',
    show: true,
    width: 112,
    valuesExport: ['type']
  },
  {
    isSortable: true,
    field: 'id',
    title: 'ID',
    show: true,
    width: 152,
    valuesExport: ['id']
  },
  {
    isSortable: true,
    field: 'role',
    title: 'Role',
    show: true,
    width: 112,
    valuesExport: ['role']
  },
  {
    isSortable: true,
    field: 'score',
    title: 'CSAT Score',
    fromToGroup: true,
    show: true,
    width: 142,
    valuesExport: ['score']
  },
  {
    isSortable: false,
    field: 'comment',
    title: 'Comments',
    show: true,
    width: 282,
    valuesExport: ['comment']
  },
  {
    isSortable: true,
    field: 'responseTime',
    title: 'Response Time',
    fromToGroup: true,
    show: true,
    width: 182,
    valuesExport: ['responseTime']
  },
  {
    isSortable: true,
    field: 'createdAt',
    title: 'Created At',
    show: true,
    width: 152,
    valuesExport: ['createdAt']
  }
];

export const exportConfigCsat = {
  exportUrl: '/customer/satisfaction/csat/export',
  exportName: 'csat',
  exportFormat: 'zip'
};

export const defaultFilters = {
  search: '',
  role: [],
  assigneeName: [],
  createdAt: { startDate: null, endDate: null }
};

export const defaultNavigation = {
  fieldName: 'createdAt',
  direction: initialTableShow.direction,
  currentPage: initialTableShow.currentPage,
  itemsPerPage: initialTableShow.itemsPerPage,
  score: {
    from: '',
    to: ''
  },
  responseTime: {
    from: '',
    to: ''
  }
};

export const charts = {
  chart: ['scoreOverTime', 'responseOverTime'],
  chartLabel: ['Score/Rating over time', 'Response over time (Minutes)']
};

export const scoreOverTimeConfig = [
  {
    name: 'chat',
    value: true,
    color: colorsNew[0]
  },
  {
    name: 'ticket',
    value: true,
    color: colorsNew[5]
  }
];
